import * as React from 'react';
import PropTypes from 'prop-types';
import {
    withStyles,
    List,
    ListItem,
    Typography,
} from '@material-ui/core';

import {
    PersonIcon,
} from '../../../common/icons';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        height: 48,
        marginBottom: theme.spacing(1),
        padding: 0,
    },
    text: {
        flex: '1 1 auto',
    },
    role: {
        color: theme.colors.grey3,
    },
    personIcon: {
        fontSize: theme.sizes.mediumIcon,
        marginRight: theme.spacing(1),
    },
    contactIcon: {
        padding: theme.spacing(0.5),
    },
    popperContent: {
        padding: theme.spacing(1),
    },
});

const ResourceStudentList = ({ persons, classes }) => {
    if (!persons) {
        return null;
    }

    return (
        <List>
            {persons.map(person => (
                <ListItem key={person.key} className={classes.root}>
                    <PersonIcon className={classes.personIcon} color="secondary" />
                    <div className={classes.text}>
                        <Typography variant="h6">{ person.name}</Typography>
                    </div>
                    {person.class && (
                        <Typography className={classes.role}>{ person.class}</Typography>
                    )}
                </ListItem>
            ))}
        </List>
    );
};

ResourceStudentList.propTypes = {
    persons: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ResourceStudentList);
